import {
  isSendableWhatsAppTemplateStatus,
  isWhatsAppTemplateCategory,
} from "@hightouch/lib/cep/types/whatsapp-template";

import { readWhatsAppTemplateStatus } from "src/cep/assets/whatsapp-templates/whatsapp-template-status";
import type { WhatsAppMessageTemplate } from "src/cep/messages/use-whatsapp-message-template";

export function readTransactionalFromTemplateCategory(
  category: string | null | undefined,
): boolean | null {
  if (!category || !isWhatsAppTemplateCategory(category)) return null;
  return category !== "MARKETING";
}

/** Meta moved a template requested as Utility to Marketing after reviewing it. */
export function wasRecategorizedAsMarketing(
  locale: WhatsAppMessageTemplate["locale"],
): boolean {
  return (
    locale?.category?.toUpperCase() === "MARKETING" &&
    locale.requested_category?.toUpperCase() !== "MARKETING"
  );
}

/** Meta moved an approved template requested as Utility to Marketing while the message still sends as transactional. */
export function isRecategorizedWhileTransactional({
  locale,
  transactional,
}: {
  locale: WhatsAppMessageTemplate["locale"];
  transactional: boolean | null | undefined;
}): boolean {
  return (
    Boolean(transactional) &&
    isSendableWhatsAppTemplateStatus(
      readWhatsAppTemplateStatus(locale?.status),
    ) &&
    wasRecategorizedAsMarketing(locale)
  );
}
